import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {SearchController} from "../../helpers/search-controller";
import {NavigationState} from "../../helpers/navigation-state";
import {QueryService} from "../../services/query.service";
import {ModalService} from "../../services/modal.service";
import {WatchService} from "../../services/watch.service";
import {DocumentService} from "../../services/document.service";
import {CollectionService} from "../../services/collection.service";
import {LoaderService} from "../../services/loader.service";
import {BusService} from "../../services/bus.service";
import {CollectionParams} from "../../helpers/params/collection-params";
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";
import {Subject} from "rxjs/Subject";


@Component({
  selector: 'nv-collection',
  templateUrl: './nv-collection.component.html',
  styles: []
})
export class NvCollectionComponent implements OnInit, OnDestroy {
  list: IDocument[];
  nav: NavigationState;
  searchController: SearchController;
  _collectionParams:CollectionParams;

  private unsubscribe: Subject<void> = new Subject<void>();


  @Input() set collectionParams(v:CollectionParams) {
    this._collectionParams = v;
    this.searchController.setParams(
      this.collectionParams.getSearchParams(),
      this.collectionParams.getFilterParams());
  }


  get collectionParams() {
    return this._collectionParams;
  }


  constructor(public documentService: DocumentService,
              private busService: BusService,
              private collectionService: CollectionService,
              private watchService: WatchService,
              private modalService: ModalService,
              private queryService: QueryService,
              private loaderService: LoaderService) {
    this.searchController = new SearchController(() => this.loadList());
    this.nav = new NavigationState(() => this.loadList());
  }


  getDocumentLabel(item: IDocument): string {
    return this.collectionParams.processItemLabel(item);
  }


  ngOnInit(): void {
    this.busService.onDocumentSaved
      .takeUntil(this.unsubscribe)
      .subscribe(() => {
      this.loadList();
      this.loadDocument();
    });


    this.loadList();
    this.loadDocument();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  loadDocument(){
    let documentId = this.queryService.documentId;
    if (documentId) {
      this.documentService.load(this.collectionParams.getEndpointId(), this.collectionParams.getObjectType(), documentId);
    }
  }


  loadList() {
    const params = paramsHelper.loader()
      .setEndpointId(this.collectionParams.getEndpointId())
      .setNavParams(this.nav.offset, this.nav.limit)
      .setObjectType(this.collectionParams.getObjectType())
      .setSearchParams(this.searchController.collectSearchParams());

    this.collectionService.loadChunk(params)
      .subscribe(r => {
        this.list = r.documents;
        this.nav.update(r.offset, r.count);
      });
  }


  onAddClicked(subtype: string = null) {
    this.nav.prepareToShowLastPage();
    this.documentService.addNew(this.collectionParams.getEndpointId(), this.collectionParams.getObjectType(), subtype);
  }


  onDuplicateClick() {
    if (this.watchService.hasChanges) {
      this.modalService.showUnsavedWarning();
      return;
    }

    this.nav.prepareToShowLastPage();
    this.documentService.duplicate();
  }


  protected onEditClick(document: IDocument, $event?: MouseEvent) {
    if ($event) {
      $event.stopPropagation();
    }

    if (this.watchService.hasChanges) {
      this.modalService.showUnsavedWarning();
      return;
    }

    this.documentService.load(this.collectionParams.getEndpointId(), this.collectionParams.getObjectType(), document._id);
  }


  getDocumentLinkQueryParams(document: IDocument) {
    return {_id: document._id};
  }


  isCurrentDocument(document: IDocument): boolean {
    return this.documentService.document
      && this.documentService.document._id === document._id;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-collection/nv-collection.component.ts